import React from "react";

export default function Badges() {
  const stats = [
    { label: "Mobile apps", value: "5+ yrs" },
    { label: "Backend systems", value: "5+ yrs" },
    { label: "Hourly", value: "$35/hr" },
    { label: "Projects", value: "from $3,500" },
  ];
  return (
    <div className="max-w-6xl mx-auto px-6 mt-4 mb-[-8px]">
      <div className="flex flex-wrap gap-2">
        {stats.map((s) => (
          <span key={s.label} className="font-mono text-[11px] font-medium uppercase tracking-wider border-2 border-black/15 dark:border-white/20 bg-white/80 dark:bg-black/50 px-3 py-1.5 text-stone-700 dark:text-stone-300">
            <span className="font-bold text-black dark:text-white">{s.label}</span>
            <span className="mx-1.5 text-stone-400">|</span>
            {s.value}
          </span>
        ))}
      </div>
    </div>
  );
}
